import * as Yup from 'yup';
import { checkBoxRequried, emailRequired, nameOptional, nameRequired, numberRequired, phoneNumberRequired, stringOptional, stringRequired } from '.';

export const dealSchema = Yup.object({
    title: nameRequired,
    email: emailRequired,
    company: nameRequired,
    phone: phoneNumberRequired,
    pipeline_id: Yup.string()
        .notOneOf(['0', ''], 'Pipeline must be selected')
        .required('pipeline required'),
    stage_id: Yup.string()
        .notOneOf(['0', ''], 'Stage must be selected')
        .required('Stage Required'),
    due_date: stringOptional,
    disable_automation: checkBoxRequried,
    custom_field1: stringOptional,
    custom_field2: stringOptional,
    custom_field3: stringOptional,
    custom_field4: stringOptional,
    custom_field5: stringOptional
});

export const customFieldSchema = Yup.object({
    customField1: nameOptional,
    customField2: nameOptional,
    customField3: nameOptional,
    customField4: nameOptional,
    customField5: nameOptional
});


export const editDealFirstPhaseSchema = Yup.object({
    deal_id: numberRequired,
    deal_name: stringRequired,
    deal_email: emailRequired,
    deal_phone: phoneNumberRequired,
    deal_address: stringOptional,
    deal_state: stringOptional,
    deal_city: stringOptional,
    deal_zip: stringOptional,
    custom_field_1: stringOptional,
    custom_field_2: stringOptional,
    custom_field_3: stringOptional,
    custom_field_4: stringOptional,
    custom_field_5: stringOptional
});

export const editDealSecondPhaseSchema = Yup.object({
    deal_website: stringOptional
});
